import { Editor, Extension, InputRule } from "@tiptap/core";
// Importing the list extension's types here keeps `toggleTaskList` on the chained-command
// surface available to this module regardless of import order elsewhere.
import "@tiptap/extension-list";

// StarterKit converts `- ` into a bullet on the first space, so GFM's `- [ ] ` muscle memory never
// reaches a task-list rule — the `[ ]` ends up as literal text inside a bullet. This rule catches
// `[ ]`/`[x]`/`[]` typed (with the trailing space) inside that freshly-made bullet and converts the
// list into a checklist, so `- [ ] ` and `- [x] ` behave the way they do in GitHub/Jira Markdown.
//
// It deliberately fires ONLY inside a bullet list: a plain `[ ] ` on an empty line is already handled
// by TaskItem's own input rule. A higher priority guarantees this rule is tried before that one for
// the bullet case (where both regexes match), so we convert the list instead of nesting a checklist.
const TASK_IN_BULLET_RE: RegExp = /^\s*\[([ xX]?)\]\s$/;

export const DashTaskList = Extension.create({
  name: "dashTaskList",
  priority: 200,

  addInputRules() {
    const editor: Editor = this.editor;
    return [
      new InputRule({
        find: TASK_IN_BULLET_RE,
        handler: ({ range, match, chain }) => {
          // Outside a bullet list, defer to TaskItem's native rule (empty line → checklist).
          const inBullet: boolean = editor.isActive("bulletList");
          if (!inBullet) return null;
          const checked: boolean = (match[1] ?? "").toLowerCase() === "x";
          chain().deleteRange(range).toggleTaskList().updateAttributes("taskItem", { checked }).run();
        }
      })
    ];
  }
});
